// extracted by mini-css-extract-plugin
export var active = "ProductOptions-mps-module--active--e4fda";
export var label = "ProductOptions-mps-module--label--a01df";
export var optionContainer = "ProductOptions-mps-module--optionContainer--2519b";
export var optionList = "ProductOptions-mps-module--optionList--25677";
export var outOfStock = "ProductOptions-mps-module--outOfStock--d7b58";
export var productOptions = "ProductOptions-mps-module--productOptions--b472e";
export var rectangleOption = "ProductOptions-mps-module--rectangleOption--5de24";
export var rectangleSelection = "ProductOptions-mps-module--rectangleSelection--f2301";
export var swatchSelection = "ProductOptions-mps-module--swatchSelection--8957f";